/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Seo_DescriptionInputs */

const cs_form_seo_description = /** @type {(inputs: Form_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO popis`)
};

const en_form_seo_description = /** @type {(inputs: Form_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO description`)
};

/**
* | output |
* | --- |
* | "SEO description" |
*
* @param {Form_Seo_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_seo_description = /** @type {((inputs?: Form_Seo_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Seo_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_seo_description(inputs)
	return cs_form_seo_description(inputs)
});